// Single source of truth for the four EDCTP Regional Networks of Excellence,
// shown in NetworkPreviewDialog wherever it's used (the homepage's "View"
// links and the /network-of-excellence page's own "More info" links).
export const networksOfExcellence = [
  {
    id: 1,
    title: 'CANTAM',
    logo: '/f59e77b2387e5ea09884dba3b5b2d7a8b130ddbe.png',
    image: '/phpw9N59X.jpeg',
    website: 'https://www.cantam.net',
    content: `
      In Central Africa, the Central African Network on TB, HIV/AIDS and malaria (CANTAM) joins institutions involved in clinical trials.
      The Network started its activities on <strong>19 December 2008</strong>.
      <br><br>
      The COVID-19 pandemic exposed deficiencies in African health systems, underscoring the demand for skilled female Ph.D. scientists in clinical research.
      In 2020, CANTAM, with support from EDCTP, initiated the ‘Women in Science’ female Ph.D. fellowship program. This program aims to address discipline gaps in the Central region by supporting female Ph.Ds and MScs in health sciences while enhancing mentorship opportunities for women scientists in Central Africa.
    `,
    extraLink: 'https://cantam.net/en/wise-alumini/'
  },
  {
    id: 2,
    title: 'WANETAM',
    logo: '/ef2e00d8191b6c1764ef28e55ae2b4647be55ff0.png',
    image: '/php3c8d9X.jpeg',
    website: 'https://www.wanetam.org',
    content: `
      The West African Network on TB, AIDS and Malaria (WANETAM) builds capacity to prepare West African sites for clinical trials on HIV, TB and malaria.
      The network started its activities on <strong>31 July 2009</strong>.
      <br><br>
      In 2020, with support from EDCTP, WANETAM established a gender-sensitive capacity-building platform for clinical research in West Africa —
      the <strong>TALENT Fellowship Program</strong>. The initiative aims to empower world-class, technically competent, and multidisciplinary women scientists.
      The goal is to advance research on emerging and endemic infectious diseases including Tuberculosis, AIDS, malaria, and COVID-19 in Sub-Saharan Africa.
    `,
    extraLink: 'https://thetalentfellowship.org/'
  },
  {
    id: 3,
    title: 'EACCR',
    logo: '/9849c5b04e343f250e6823c2b762598793984c8e.png',
    image: '/phpk2r2Bz.jpeg',
    website: 'https://www.eaccr.org',
    content: `
      The East African Consortium for Clinical Research (EACCR) strengthens clinical trial sites in Eastern Africa.
      The Network started on <strong>14 May 2009</strong>.
      <br><br>
      The <strong>Capacity Building for Female Scientists in East Africa (CAFÉ-SEA)</strong> fellowship programme, supported by EDCTP, operates within EACCR.
      The programme addresses the under-representation of women in infectious disease research in Eastern Africa.
      Recognising the challenges faced by women in academic science careers, CAFÉ-SEA strengthens research capacity through multidisciplinary PhD training and mentorship —
      crucial for addressing regional epidemics such as Ebola and COVID-19.
    `,
    extraLink: 'https://www.eaccr.org/cafe-sea'
  },
  {
    id: 4,
    title: 'TESA',
    logo: '/29f2e91070939608d8928a196071004c7a5f466e.png',
    image: '/phpNkP5fN.jpeg',
    website: 'https://tesanetwork.org/tesa-homepage/',
    content: `
      The Trials of Excellence in Southern Africa (TESA) is a regional network established in <strong>2009</strong> under the first programme of the European and Developing Countries Clinical Trials Partnership (EDCTP1).
      The objective is to create a framework for collaboration, capacity building, and training among institutions across the Southern African region.
      <br><br>
      Under EDCTP2, the network expanded to fifteen institutions across eight Southern African countries and four European countries.
      <br><br>
      TESA also addresses gender equity in research capacity through the <strong>TAGENDI Fellowship Programme</strong>, supporting women scientists to address the gender gap in clinical research across the region.
    `,
    extraLink: 'https://tesanetwork.org/tagendi/'
  }
]
